import { render, staticRenderFns } from "./ModelFour.vue?vue&type=template&id=7d1cb077&scoped=true"
import script from "./ModelFour.vue?vue&type=script&lang=js"
export * from "./ModelFour.vue?vue&type=script&lang=js"
import style0 from "./ModelFour.vue?vue&type=style&index=0&id=7d1cb077&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1cb077",
  null
  
)

export default component.exports